<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :auto-complete="autoComplete"
            :dense="dense"
            :showAdd="showAdd"
        />
        <sys-register-sub-group @onCompleted="newItem" :model="{}" :group="group" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectSubGroup',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false,
        group_id: null,
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        group: {},
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },

        group(val){
            
            if(val && val.id && val.id != this.group_id){
                this.getItems();
            }
        }
    },
    methods: {
        ...mapActions('group', ['ActionIndexSubGroups']),        
        
        async getItems() {

            this.loading = true;
            this.items = [];
            this.group_id = this.group.id;

            var payload = {
                find_columns: {
                    group_id: this.group_id,
                }
            }

            await this.ActionIndexSubGroups(payload)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>